import type { DateRange } from 'react-day-picker';
import type { FilterControl } from '../../../types/filterControl';
import type { TableQuickFilter } from '../../../types/table';

/** The toolbar date range. A filter like any other, so its dates are written as params too. */
type TableDateRangeFilter = {
  value: DateRange | undefined;
  onChange: (dateRange: DateRange | undefined) => void;
  /** Names the date the range filters, for a table whose rows carry more than one. */
  placeholder?: string;
};

/** What a `compose` filter renders. A bare control or list is shorthand for `{ controls }`. */
export type ControlSet = {
  controls?: FilterControl[];
  quickFilter?: TableQuickFilter;
  dateRange?: TableDateRangeFilter;
};
export type Controls = FilterControl | FilterControl[] | ControlSet;

declare const filterUnitBrand: unique symbol;

/**
 * One filter: the controls it renders and the params it sends. Tables take only units, and only
 * `filterUnitFor` / `combineFilterUnits` build one, so a control cannot reach a table without its
 * params, and a param the endpoint does not accept is a type error rather than a silent no-op.
 */
export type FilterUnit<TInput> = {
  controls: FilterControl[];
  quickFilter?: TableQuickFilter;
  dateRange?: TableDateRangeFilter;
  apiInput: TInput;
  readonly [filterUnitBrand]: true;
};

/** Only this package's builders call it, so a unit always comes with the params its controls write. */
export const brand = <TInput>(unit: Omit<FilterUnit<TInput>, typeof filterUnitBrand>) => unit as FilterUnit<TInput>;
